import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ScheduleType} from "../../types/schedule.type";

export class ScheduleTypesMultiSelectListComponent implements IController {
  scheduleTypes: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(ScheduleType));
    }
  }

  $onChanges(changes) {
    if (changes.scheduleTypes) {
      this.selectedKeys = [];
      _.forEach(this.scheduleTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      scheduleTypes: isSelected ? _.concat(this.scheduleTypes, [option]) :
        _.filter(this.scheduleTypes, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({scheduleTypes: []});
  }

}

angular
  .module('bringoz.admin.schedule')
  .component('scheduleTypesMultiSelectList', {
    bindings: {
      scheduleTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./schedule-types-multi-select-list.html').default,
    controller: ScheduleTypesMultiSelectListComponent
  });
